<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
                <b-row>
                    <b-col xl="12" lg="12" sm="12">
                        <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                            <b-form @submit.prevent="handleSubmit(register)" @reset.prevent="reset">
                                <b-row>
                                    <b-col lg="12" sm="12">
                                        <ValidationProvider name="Hospital Name" vid="hospital_category" rules="required|min_value:1">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="4"
                                                label-for="hospital_category "
                                                slot-scope="{ valid, errors }"
                                                >
                                                <template v-slot:label>
                                                    {{$t('hospital_configuration.hos_name')}} <span class="text-danger">*</span>
                                                </template>
                                                <b-form-select
                                                plain
                                                v-model="office.hospital_id"
                                                :disabled="id ? true : false"
                                                id="hospital_category"
                                                :options="hospitalList"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                >
                                                <template v-slot:first>
                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                </template>
                                                </b-form-select>
                                                <span  v-if="id"></span><span v-else class="text-danger" style="font-size:12px">{{$t('hospital_configuration.has_samiti')}}</span>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                        <ValidationProvider name="Registration no." vid='registration_no' rules="required">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="4"
                                                label-for="registration_no"
                                                slot-scope="{ valid, errors }"
                                            >
                                                <template v-slot:label>
                                                {{ $t('hospital_configuration.registration_no')}} <span class="text-danger">*</span>
                                                </template>
                                                <b-form-input
                                                id="office_name"
                                                v-model="office.registration_no"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                ></b-form-input>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                        <ValidationProvider name="Date" vid='date' rules="required">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="4"
                                                label-for="date"
                                                slot-scope="{ valid, errors }"
                                            >
                                                <template v-slot:label>
                                                {{ $t('globalTrans.date')}} <span class="text-danger">*</span>
                                                </template>
                                                <b-form-input
                                                class="date-picker"
                                                v-model="office.reg_date"
                                                :placeholder="$t('globalTrans.date')"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                id="date"
                                                >
                                                </b-form-input>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                        <ValidationProvider name="Mobile no." vid='mobile_no' rules="numeric|min:8">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="4"
                                                label-for="mobile_no"
                                                slot-scope="{ valid, errors }"
                                            >
                                                <template v-slot:label>
                                                {{ $t('user.phone_no')}}
                                                </template>
                                                <b-form-input
                                                id="mobile_no"
                                                v-model="office.mobile_no"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                ></b-form-input>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col lg="12"  sm="12">
                                    <ValidationProvider name="Email" vid="email" rules="required">
                                        <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="email"
                                        slot-scope="{ valid, errors }"
                                        >
                                        <template v-slot:label>
                                        {{$t('educational_management.email')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-input-group>
                                        <b-input-group-prepend>
                                            <span class="input-group-text"><i class="fa fa-envelope fa-sm"></i></span>
                                        </b-input-group-prepend>
                                        <b-form-input class="form-control"
                                            v-model="office.email"
                                            placeholder="Email"
                                            id="email"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                        </b-input-group>
                                        </b-form-group>
                                    </ValidationProvider>
                                  </b-col>
                                </b-row>
                                <div class="row">
                                <div class="col-sm-3"></div>
                                <div class="col text-right">
                                    <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                    &nbsp;
                                    <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                                </div>
                                </div>
                            </b-form>
                        </ValidationObserver>
                    </b-col>
                </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { hospitalServiceBaseUrl } from '../../../../../config/api_config'
import { patientWelfareStoreApi, patientWelfareUpdateApi } from '../../api/routes'
import flatpickr from 'flatpickr'

export default {
    name: 'FormLayout',
    props: ['id', 'item'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    created () {
        this.hospitalList = this.getHospitalList()
        if (this.id) {
            const tmp = this.getOfficeData()
            // Object.freeze(tmp)
            this.office = tmp
        }
    },
    mounted () {
        flatpickr('.date-picker', {})
        core.index()
    },
    data () {
        return {
            reg_detail: '',
            hospitalList: [],
            hospitalListData: [],
            saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            office: {
                reg_date: '',
                email: '',
                registration_no: '',
                hospital_id: '0',
                mobile_no: '',
                created_by: 1,
                updated_by: 1
            }
        }
    },
    computed: {
    },
    watch: {
    },
    methods: {
        getHospitalList () {
            let hospitalList = this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1)
            hospitalList = hospitalList.map(obj => {
                if (obj.has_samiti === 1) {
                    return { value: obj.value, text: this.$i18n.locale === 'en' ? obj.text_en : obj.text_bn, disabled: true }
                } else {
                    return { value: obj.value, text: this.$i18n.locale === 'en' ? obj.text_en : obj.text_bn }
                }
            })
        return hospitalList
        },
        getOfficeData () {
          const tmpData = this.$store.state.list.find(item => item.id === this.id)
          return JSON.parse(JSON.stringify(tmpData))
        },
        async register () {
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            let result = null
            const loadinState = { loading: false, listReload: true }
            if (this.id) {
                result = await RestApi.putData(hospitalServiceBaseUrl, `${patientWelfareUpdateApi}/${this.id}`, this.office)
            } else {
                result = await RestApi.postData(hospitalServiceBaseUrl, patientWelfareStoreApi, this.office)
            }

            this.$store.dispatch('mutateCommonProperties', loadinState)

            if (result.success) {
                this.$store.dispatch('mutateCommonProperties', { hasDropdownLoaded: false })
                this.$store.dispatch('HospitalDisabilityService/mutateCommonObj', { hasDropdownLoaded: false })
                this.$toast.success({
                title: this.$t('globalTrans.success'),
                message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                color: '#D6E09B'
                })

                this.$bvModal.hide('modal-4')
            } else {
                this.$refs.form.setErrors(result.errors)
            }
        }
    }
}
</script>
<style>
select option:disabled {
    color: green !important;
    font-weight: bold;
}
</style>
